var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-5041e3da"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["contenteditable", "data-placeholder"];
import { ref, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import Dom from '@common/utils/Dom';
import { escapeHTML } from '@common/utils/String/String';
import SelectionUtils from '@common/utils/Selection';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContentEditable',
    props: /*#__PURE__*/ _mergeModels({
        placeholder: { default: '' },
        readonly: { type: Boolean, default: false },
        inlineBlock: { type: Boolean, default: true },
        lineBreaks: { type: Boolean, default: true },
        pasteTags: { type: Boolean, default: true }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels([
        'change',
        'input',
        'blur',
        'keydown',
        'paste',
    ], ["update:modelValue"]),
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var modelValue = _useModel(__props, "modelValue");
        var emit = __emit;
        var selection = new SelectionUtils();
        var contentRef = ref(null);
        var mutationObserver = new MutationObserver(function () {
            emitChange();
        });
        onMounted(function () {
            mutationObserver.observe(contentRef.value, {
                subtree: true,
                characterData: true,
                childList: true,
            });
        });
        onBeforeUnmount(function () {
            mutationObserver.disconnect();
        });
        watch([contentRef, modelValue], function (_a) {
            var _b = __read(_a, 2), ref = _b[0], val = _b[1];
            if (ref) {
                var valHtml = ref.innerHTML;
                if (val !== valHtml) {
                    ref.innerHTML = modelValue.value || '';
                }
            }
        }, { immediate: true });
        var onKeyDown = function (e) {
            var _a;
            if (!props.lineBreaks && e.key === 'Enter') {
                e.preventDefault();
            }
            // Если видимого содержимого нет - удаляем все теги внутри
            if ((e.code === 'Backspace' || e.code === 'Delete') && ((_a = contentRef.value) === null || _a === void 0 ? void 0 : _a.textContent) === '') {
                contentRef.value.innerHTML = '';
            }
            emit('keydown', e);
        };
        var emitChange = function () { return __awaiter(_this, void 0, void 0, function () {
            var value;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!contentRef.value || modelValue.value === ((_a = contentRef.value) === null || _a === void 0 ? void 0 : _a.innerHTML)) {
                            return [2 /*return*/];
                        }
                        value = contentRef.value.innerHTML;
                        modelValue.value = value;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _b.sent();
                        emit('change', contentRef.value.innerHTML);
                        emit('input', contentRef.value.innerHTML);
                        return [2 /*return*/];
                }
            });
        }); };
        var onPaste = function (e) {
            var e_1, _a;
            if (!props.pasteTags) {
                var clipboardData = (e.clipboardData || window.clipboardData);
                var pasteText = clipboardData.getData('text');
                if (!selection.range)
                    return false;
                selection.range.deleteContents();
                var content = Dom.stringToDom(escapeHTML(pasteText).replace(/\r\n|\r|\n/g, props.lineBreaks ? '<br />' : ''));
                var nodes = [];
                var nodeIterator = document.createNodeIterator(content.body, NodeFilter.SHOW_ALL);
                var node = nodeIterator.nextNode();
                while (node) {
                    if (node.nodeName !== 'BODY') {
                        nodes.push(node);
                    }
                    node = nodeIterator.nextNode();
                }
                try {
                    // вставляем в обратном порядке, тк insertNode вставляет в начало
                    for (var _b = __values(nodes.toReversed()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var nodeElement = _c.value;
                        selection.range.insertNode(nodeElement);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                selection.collapseToEnd();
                e.preventDefault();
            }
            emit('paste', e);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "contentRef",
                ref: contentRef,
                class: _normalizeClass([[
                        _ctx.inlineBlock && 'inline-block'
                    ], "editable-text"]),
                contenteditable: !_ctx.readonly,
                "data-placeholder": _ctx.placeholder,
                onBlur: _cache[0] || (_cache[0] = function ($event) { return (emit('blur', $event)); }),
                onKeydown: onKeyDown,
                onPaste: onPaste
            }, null, 42, _hoisted_1));
        };
    }
});
